import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { BasketUpsellInput, BasketUpsellResponse } from './interfaces/basketUpsell'

const getBasketUpsellResponseParser = async (response: Response): Promise<BasketUpsellResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return response.json() as Promise<BasketUpsellResponse>
}

export const basketUpsellFetcher = composeFetch(
  composeRequest<BasketUpsellInput>(
    setServiceUrl('menuexperience', 1),
    addPath((input) => `menu/${input.menuId}/upsell`),
    goustoHeaders,
    setMethod('GET'),
    setQueryParams(({ numPortions, deliveryDate, postcode, recipeIds }) => ({
      numPortions: numPortions.toString(),
      deliveryDate,
      postcode,
      recipeIds,
    })),
  ),
  getBasketUpsellResponseParser,
)
